import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ExclamationTriangleIcon, MagnifyingGlassIcon, WifiIcon } from '@heroicons/react/24/outline';
import { Button } from '../ui';

const pages = {
  404: {
    title: 'Page not found',
    message: "The page you're looking for doesn't exist or has been moved.",
    icon: MagnifyingGlassIcon,
  },
  403: {
    title: 'Access denied',
    message: "You don't have permission to view this page.",
    icon: ExclamationTriangleIcon,
  },
  500: {
    title: 'Something went wrong',
    message: "We're working on fixing this. Please try again later.",
    icon: ExclamationTriangleIcon,
  },
  offline: {
    title: "You're offline",
    message: 'Check your internet connection and try again.',
    icon: WifiIcon,
  },
};

export default function ErrorPage({ statusCode = 500, variant, title, message }) {
  const navigate = useNavigate();
  const key = variant || statusCode;
  const defaults = pages[key] || pages[500];
  const Icon = defaults.icon;

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-md px-6">
        <Icon className="h-16 w-16 text-gray-300 mx-auto mb-4" />
        {!variant && (
          <p className="text-6xl font-bold text-primary-600 mb-2">{statusCode}</p>
        )}
        <h1 style={{ font: 'var(--text-h1)', color: 'var(--color-text-primary)', marginBottom: '0.5rem' }}>
          {title || defaults.title}
        </h1>
        <p className="text-gray-500 mb-6">
          {message || defaults.message}
        </p>
        <Button
          onClick={() => variant === 'offline' ? window.location.reload() : navigate('/quotes')}
        >
          {variant === 'offline' ? 'Retry' : 'Go to Dashboard'}
        </Button>
      </div>
    </div>
  );
}
